import { Modal, ModalBody, ModalHeader } from "@design-lab/shared/ui/modal";
import { ExampleIllustration } from "./ExampleIllustration";
import { ExampleOutput } from "./ExampleOutput";

type HelpModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function HelpModal({ isOpen, onClose }: HelpModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="translate-none bottom-0 left-0 top-auto flex h-auto max-h-[90vh] w-full flex-col rounded-b-none"
      closeOnBackdropClick={true}
      closeOnEsc={true}
    >
      <ModalHeader onClose={onClose}>Example Prompt</ModalHeader>
      <ModalBody className="space-y-4 p-4">
        {/* Style/Subject tabs */}
        <ExampleIllustration />

        {/* Example Output */}
        <ExampleOutput />
      </ModalBody>
    </Modal>
  );
}
